import { DEFAULT_LABEL_ZOOM, DEFAULT_LABEL_SIZES } from 'helpers/globals'

export default function getLabelSize(zoom) {
  // set the scale based off the current zoom (higher zoom => smaller label)
  const scale = Math.pow(2, DEFAULT_LABEL_ZOOM - zoom)

  // ensure scale is one of our preset values
  if (DEFAULT_LABEL_SIZES.includes(scale)) return scale
  else if (scale < Math.min(...DEFAULT_LABEL_SIZES)) return Math.min(...DEFAULT_LABEL_SIZES)
  else return Math.max(...DEFAULT_LABEL_SIZES)
}



// WEBPACK FOOTER //
// ./src/helpers/markups/getLabelSize.js